function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "a",
  cx: 27,
  cy: 27,
  r: 27,
  fill: "#FFFBED"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13 14)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 28,
  height: 26,
  rx: 1,
  fill: "#BE9C38"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.83251 1.7931)",
  fill: "#FFFBED"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.096059,
  y: 0.064039,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 4.7389,
  y: 0.064039,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9.3818,
  y: 0.064039,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.025,
  y: 0.064039,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 18.667,
  y: 0.064039,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 23.31,
  y: 0.064039,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.096059,
  y: 19.564,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 4.7389,
  y: 19.564,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9.3818,
  y: 19.564,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.025,
  y: 19.564,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "b",
  x: 18.667,
  y: 19.564,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 23.31,
  y: 19.564,
  width: 2.7857,
  height: 2.7857,
  rx: 1
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 6,
  fill: "#0C5860"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.44 23.996c-0.11036-0.055938-0.24679-0.056876-0.35786-9.375e-4 -0.11107 0.055938-0.17929 0.15906-0.17929 0.27094v4.3751c0 0.11219 0.068214 0.21532 0.17929 0.27094 0.055 0.027813 0.11643 0.041563 0.17786 0.041563 0.062143 0 0.12464-0.014375 0.18-0.042501l4.2857-2.1875c0.11-0.055938 0.17714-0.15875 0.17714-0.27 0-0.11094-0.067143-0.21375-0.17714-0.27l-4.2857-2.1875z",
  fill: "#53A478"
})));

function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design/icon/media") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.902a486b.svg";
export { ForwardRef as ReactComponent };